import { ApiService } from "@/api";

export const updateAnswerProcess = (sampleId: string, process: number) => {
  return ApiService.baseAction(
    `answer/${sampleId}/process`,
    {
      data: {
        process,
      },
    },
    "POST"
  );
};
